import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react'; // 引入关闭图标
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Banner from '@/components/Banner';
import ServiceCards from '@/components/ServiceCards';
import StatsSection from '@/components/StatsSection';
import Testimonials from '@/components/Testimonials';
import CTASection from '@/components/CTASection';
import ShoppingCards from '@/components/ShoppingCards';
import PlatformCards from '@/components/PlatformCards';

// 导入背景图片
import modalBg from '@/assest/imgs/kuangBg.png';

export default function Home() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [noRemindToday, setNoRemindToday] = useState(false);

  useEffect(() => {
    // 1. 检查 localStorage 中是否有“今日不再提醒”的记录
    // const lastRemindDate = localStorage.getItem('home_modal_last_remind');
    // const today = new Date().toDateString(); // 获取当前日期字符串，例如 "Mon Oct 23 2023"

    // if (lastRemindDate !== today) {
    //   // 如果上次提醒不是今天，则显示弹窗
    //   setShowModal(true);
    // }
  }, []);

  const handleClose = () => {
    if (noRemindToday) {
      // 如果勾选了“今日不再提醒”，记录今天的日期
      localStorage.setItem('home_modal_last_remind', new Date().toDateString());
    }
    setShowModal(false);
  };

  const handleImageClick = () => {
    // 2. 判断是否登录
    // 假设 token 存储在 localStorage 的 'token' 字段中，请根据你实际的存储 key 调整
    const token = localStorage.getItem('token'); 
    
    if (token) {
      // 已登录，跳转到个人中心
      navigate('/console/profile');
    } else {
      // 未登录，跳转到登录页
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen flex flex-col relative">
      <Header />
      <main className="flex-1 pt-20">
        <Banner />
        <ShoppingCards />
        <PlatformCards />
        {/* <ServiceCards /> */}
        <StatsSection />
        {/* <Testimonials /> */}
        <CTASection />
      </main>
      <Footer />

      {/* 弹框区域 */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          {/* 
             宽度控制：
             - w-full: 基础宽度
             - md:w-1/3: 在中等屏幕及以上（桌面端），宽度为屏幕的 1/3
          */}
          <div className="relative w-full md:w-1/2 animate-in fade-in zoom-in duration-300">
            
            {/* 右上角关闭按钮 (X) - 位置稍微再往外一点，避免和内部复选框重叠 */}
            <button 
              onClick={handleClose}
              className="absolute -top-10 -right-10 text-white hover:text-gray-300 transition-colors drop-shadow-md z-20"
              aria-label="关闭"
            >
              <X className="w-8 h-8" />
            </button>

            {/* 弹框内容容器 */}
            <div className="bg-white rounded-xl overflow-hidden shadow-2xl relative group">
              {/* 背景图片作为点击区域 */}
              <div 
                className="cursor-pointer relative"
                onClick={handleImageClick}
              >
                <img 
                  src={modalBg} 
                  alt="活动宣传" 
                  className="w-full h-auto object-cover block"
                />
                
                {/* 
                   “今日不再提醒” 复选框区域 - 修改点：
                   - absolute top-4 right-4: 定位到右上角
                   - z-10: 确保在图片之上
                */}
                <div 
                  className="absolute top-4 right-4 flex items-center gap-2 bg-black/60 backdrop-blur-sm px-3 py-1.5 rounded-lg shadow-sm hover:bg-black/70 transition-colors z-10"
                  onClick={(e) => e.stopPropagation()} // 防止触发图片点击跳转
                >
                  <input
                    type="checkbox"
                    id="noRemind"
                    checked={noRemindToday}
                    onChange={(e) => setNoRemindToday(e.target.checked)}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer accent-white"
                  />
                  <label 
                    htmlFor="noRemind" 
                    className="text-xs text-white font-medium cursor-pointer select-none"
                  >
                    今日不再提醒
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}